import React from "react";
import { DEFAULT_SUPPORT_CONTACTS } from "../order-status";

function OtherStoreSupportLinks({ support, className = "" }) {
  const contacts = {
    ...DEFAULT_SUPPORT_CONTACTS,
    ...(support || {}),
  };

  return (
    <p className={`other-store-support-links ${className}`.trim()}>
      Техподдержка:{" "}
      <a
        href={contacts.telegram}
        target="_blank"
        rel="noopener noreferrer"
        className="other-store-consent-link"
      >
        Telegram
      </a>
      {", "}
      <a
        href={contacts.vk}
        target="_blank"
        rel="noopener noreferrer"
        className="other-store-consent-link"
      >
        ВКонтакте
      </a>
      {contacts.email ? (
        <>
          {", "}
          <a
            href={`mailto:${contacts.email}`}
            className="other-store-consent-link"
          >
            {contacts.email}
          </a>
        </>
      ) : null}
    </p>
  );
}

export default OtherStoreSupportLinks;
